import { render, staticRenderFns } from "./AAComponent.vue?vue&type=template&id=4e81deda&scoped=true"
import script from "./AAComponent.vue?vue&type=script&lang=js"
export * from "./AAComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e81deda",
  null
  
)

export default component.exports